export const documenetStatusOptions = [
  { value: "open", label: "Open" },
  { value: "close", label: "Close" },
];
